import React, { Component } from "react";
import { history } from "../../../helpers";
import ClinicsView from "./ClinicsView";
import { getDoctorDetails } from "../../../services";
import { showErrorNotification, getProp } from "../../../helpers";

export default class ClinicsContainer extends Component {
  state = {
    details: null,
    isProcessing: false
  };

  componentDidMount() {
    this.getDoctorInfo();
  }

  /**
   * @function getDoctorInfo.
   * @description it will get the clinic info
   */
  getDoctorInfo = () => {
    const { doctorId } = this.props;
    this.setState({ isProcessing: true });
    getDoctorDetails(doctorId)
      .then(response => {
        this.setState({ isProcessing: false });
        const getErrors = getProp(["data", "errors"]);
        const getSuccess = getProp(["data", "success"]);
        const getDataSuccess = getProp(["data", "data"]);

        if (getSuccess(response)) {
          const details = getDataSuccess(response);

          this.setState({
            details,
            isProcessing: false
          });
        } else if (getErrors(response)) {
          const { errors } = response.data;

          let error = errors;
          if (Array.isArray(errors)) {
            error = errors[0];
          }
          showErrorNotification(error.title);
          this.setState({ details: [], isProcessing: false });
        }
      })
      .catch(response => {
        const getErrors = getProp(["data", "errors"]);
        if (getErrors(response)) {
          const { errors } = response.data;
          let error = errors;
          if (Array.isArray(errors)) {
            error = errors[0];
          }
          showErrorNotification(error.title);
          this.setState({ details: [], isProcessing: false });
        }
      });
  };

  /**
   * @function  navigateToClinicDetails
   * @description This function redirect the user to clinic-details
   */
  navigateToClinicDetails = clinicId => {
    history.push(`/clinics-details/${clinicId}/basic-details`);
  };
  render() {
    const { details, isProcessing } = this.state;
    return (
      <>
        {details && (
          <ClinicsView
            details={details}
            navigateToClinicDetails={this.navigateToClinicDetails}
            isProcessing={isProcessing}
          />
        )}
      </>
    );
  }
}
